/**
 * Реестр дашбордов: доступ к каждому определяется отдельно.
 * Старые страницы /dashboard, /dashboard-oup, /dashboard-oup2 и /dashboard-oup3
 * выведены из эксплуатации и сюда не входят.
 */

export const WELCOME_PATH = '/';

export type DashboardEntry = {
  id: string;
  label: string;
  to: string;
};

type DashboardDefinition = DashboardEntry & {
  isAllowed: (hasDepartment: (...codes: string[]) => boolean) => boolean;
};

const DASHBOARD_DEFINITIONS: DashboardDefinition[] = [
  {
    id: 'oup4',
    label: 'Портфель ОУП',
    to: '/dashboard-oup4',
    isAllowed: (hasDepartment) => hasDepartment('OUP_UL'),
  },
];

export function getAccessibleDashboards(
  hasDepartment: (...codes: string[]) => boolean,
): DashboardEntry[] {
  return DASHBOARD_DEFINITIONS.filter((dashboard) => dashboard.isAllowed(hasDepartment)).map(
    ({ id, label, to }) => ({ id, label, to }),
  );
}

/** Куда вести «Главную»: первый доступный дашборд, иначе заглушка. */
export function getHomePath(dashboards: DashboardEntry[]): string {
  return dashboards[0]?.to ?? WELCOME_PATH;
}

export function isDashboardPath(pathname: string, dashboards: DashboardEntry[]): boolean {
  return dashboards.some((dashboard) => dashboard.to === pathname);
}
